/* Monica Jewelers — Jewelry Insurance Claims & Replacement
   Vanilla JS, no dependencies, no new analytics tags installed.
   Scoped entirely to [data-ic-*] hooks. */
(function () {
  'use strict';
  /* Several sections each emit this <script src>, so the file can be fetched and
     executed more than once on a page. Bind exactly once. */
  if (window.__mjInsuranceBooted) return;
  window.__mjInsuranceBooted = true;

  var SS = 'mj_ic_attr';

  /* ---------- attribution: capture once, persist across the 3 pages ---------- */
  function attribution() {
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem(SS) || '{}'); } catch (e) {}
    var qs = new URLSearchParams(location.search);
    var keys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','wbraid','msclkid'];
    var fresh = false;
    keys.forEach(function (k) { if (qs.get(k)) { stored[k] = qs.get(k); fresh = true; } });
    if (!stored.landing_page) { stored.landing_page = location.pathname; fresh = true; }
    if (!stored.referrer) { stored.referrer = document.referrer || '(direct)'; fresh = true; }
    if (fresh) { try { sessionStorage.setItem(SS, JSON.stringify(stored)); } catch (e) {} }
    return stored;
  }

  /* ---------- analytics: reuse whatever the store ALREADY loads ----------
     Never loads a tag, never creates a pixel, never sends PII. */
  function track(name, params) {
    params = params || {};
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, params)); } catch (e) {}
  }
  window.mjInsuranceTrack = track;

  /* ---------- validation ---------- */
  var RX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var RX_PHONE = /^[\d\s()+\-.]{10,}$/;

  function fieldError(el, msg) {
    var box = el.closest('.ic__field') || el.parentNode;
    var err = box.querySelector('.ic__err');
    if (!err) return;
    if (msg) { err.textContent = msg; err.classList.add('is-shown'); el.setAttribute('aria-invalid', 'true'); }
    else { err.textContent = ''; err.classList.remove('is-shown'); el.removeAttribute('aria-invalid'); }
  }

  function validate(el) {
    var label = el.getAttribute('data-label') || 'this field';
    if (el.type === 'checkbox') {
      if (el.hasAttribute('required') && !el.checked) {
        fieldError(el, 'Please tick this box so we can contact you about your request.');
        return false;
      }
      fieldError(el, null); return true;
    }
    var v = (el.value || '').trim();
    if (el.hasAttribute('required') && !v) {
      fieldError(el, (el.tagName === 'SELECT' ? 'Please choose ' : 'Please enter ') + label + '.');
      return false;
    }
    if (v && el.type === 'email' && !RX_EMAIL.test(v)) { fieldError(el, 'Please enter a valid email address.'); return false; }
    if (v && el.type === 'tel' && !RX_PHONE.test(v)) { fieldError(el, 'Please enter a valid phone number.'); return false; }
    fieldError(el, null); return true;
  }

  /* ---------- conditional fields ----------
     markup: <div class="ic__cond" data-ic-when="claim_type=Lost|Stolen"> */
  function fieldsNamed(root, name) {
    return root.querySelectorAll('[name="contact[' + name + ']"],[name="' + name + '"]');
  }

  function syncConditionals(root) {
    root.querySelectorAll('[data-ic-when]').forEach(function (panel) {
      var rule = panel.getAttribute('data-ic-when');
      var eq = rule.indexOf('=');
      var name = rule.slice(0, eq);
      var wanted = rule.slice(eq + 1).split('|').map(function (s) { return s.trim(); });
      var val = '';
      fieldsNamed(root, name).forEach(function (i) {
        if (i.type === 'radio' || i.type === 'checkbox') { if (i.checked) val = i.value; }
        else val = i.value;
      });
      var open = wanted.indexOf((val || '').trim()) !== -1;
      panel.classList.toggle('is-open', open);
      panel.querySelectorAll('input,select,textarea').forEach(function (f) {
        f.disabled = !open;                                  /* excluded from submit when closed */
        if (open) { if (f.getAttribute('data-req') === 'true') f.setAttribute('required', 'required'); }
        else { f.removeAttribute('required'); fieldError(f, null); }
      });
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var attr = attribution();
    var form = document.querySelector('[data-ic-form]');

    /* page view */
    var page = document.querySelector('[data-ic-page]');
    if (page) track('insurance_page_view', { page_type: page.getAttribute('data-ic-page') });

    /* CTA / phone / directions / appointment clicks */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ic-event]');
      if (!a) return;
      track(a.getAttribute('data-ic-event'), { link_text: (a.textContent || '').trim().slice(0, 60) });
    });

    /* sticky mobile CTA */
    var sticky = document.querySelector('[data-ic-sticky]');
    if (sticky) {
      var show = function () { if (window.scrollY > 400) sticky.classList.add('is-shown'); };
      show();
      window.addEventListener('scroll', show, { passive: true });
      if (form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { sticky.classList.toggle('is-shown', !en.isIntersecting && window.scrollY > 400); });
        }, { threshold: 0.05 }).observe(form);
      }
    }

    /* focus the success / error notice so screen readers announce it */
    var notice = document.querySelector('[data-ic-success],[data-ic-error]');
    if (notice) { try { notice.focus(); } catch (e) {} }

    if (!form) return;

    /* stamp attribution into the hidden inputs — non-PII fields only */
    form.querySelectorAll('[data-ic-attr]').forEach(function (i) {
      var k = i.getAttribute('data-ic-attr');
      if (attr[k]) i.value = attr[k];
    });

    syncConditionals(form);
    form.addEventListener('change', function () { syncConditionals(form); });

    var started = false;
    form.addEventListener('input', function () {
      if (started) return;
      started = true;
      track('insurance_form_started', {});
    });

    form.querySelectorAll('input,select,textarea').forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value || el.hasAttribute('required')) validate(el); });
      el.addEventListener('change', function () { if (el.getAttribute('aria-invalid') || el.type === 'checkbox') validate(el); });
      el.addEventListener('input', function () { if (el.getAttribute('aria-invalid')) validate(el); });
    });

    form.addEventListener('submit', function (e) {
      var bad = [];
      form.querySelectorAll('input,select,textarea').forEach(function (el) {
        if (el.type === 'hidden' || el.disabled) return;
        if (!el.hasAttribute('required') && !(el.value || '').trim()) return;
        if (!validate(el)) bad.push(el);
      });
      var note = form.querySelector('[data-ic-formerr]');
      if (bad.length) {
        e.preventDefault();
        if (note) {
          note.hidden = false;
          note.textContent = 'Please check ' + bad.length + ' field' + (bad.length > 1 ? 's' : '') + ' highlighted below.';
        }
        bad[0].focus();
        try { bad[0].scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
        return;
      }
      if (note) { note.hidden = true; note.textContent = ''; }

      /* non-PII payload ONLY — no name, email, phone, claim number or description */
      var val = function (n) { var f = form.querySelector('[name="contact[' + n + ']"]'); return f ? f.value : ''; };
      track('insurance_form_submitted', {
        preferred_store:  val('preferred_store'),
        claim_type:       val('claim_type'),
        item_type:        val('item_type'),
        desired_outcome:  val('desired_outcome')
      });
    });
  });
})();

